// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderWithBorder_header__6Aq__"};